module.exports = __webpack_public_path__ + "static/img/077.c599429.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/yqs/077.png
// module id = dUHp
// module chunks = 0